import React from 'react';
import { Outlet } from 'react-router-dom';
import ModernSidebar from './ModernSidebar';

/**
 * Modern layout with vertical sidebar
 * Content area adjusts to sidebar width
 */

function ModernLayout({ user, onLogout }) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 transition-colors duration-200">
      {/* Sidebar */}
      <ModernSidebar user={user} onLogout={onLogout} />
      
      {/* Main Content Area */}
      <div className="ml-20 min-h-screen">
        <div className="p-4 sm:p-6 lg:p-8">
          <Outlet context={{ user, onLogout }} />
        </div>
      </div>
    </div>
  );
}

export default ModernLayout;

